import React, { useState } from "react";
import Email from "assets/images/Email.png";
import CallUs from "assets/images/CallUs.png";
import { useVideoTranslation } from "hooks/Forms/useVideoTranslation";
import { useForm } from "react-hook-form";
import Loader from "components/loader";
import ThankYouPopup from "components/popup/thankYouPopup";
import { useFetchLanguages } from "hooks/Quotes/useFetchLanguages";

function NewBanner({
  backgroundCol,
  formOrangeHead,
  ftitle,
  midTitle,
  secondTitle,
  Subcontent,
  content,
  formWhiteHead,
}) {
  const [open, setOpen] = useState(false);
  const [imageupload, setImageUpload] = useState("");

  // const location = useLocation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { status, mutateAsync } = useVideoTranslation();
  const { data } = useFetchLanguages();

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("business_email", data.email);
    formData.append("description", data.message);
    formData.append("translate_from", data.fromLang);
    formData.append("translate_to", data.toLang);
    formData.append("upload_file", imageupload);
    formData.append("phone_number", data.phoneNumber);

    // const postData = {
    //   name: data.name,
    //   business_email: data.email,
    //   description: data.message,
    //   translate_from: data.fromLang,
    //   translate_to: data.toLang,
    //   upload_file: imageupload,
    //   phone_number: data.phoneNumber,
    // };
    console.log(formData);

    mutateAsync(formData).then((_) => {
      reset();
      setOpen(true);
    });
  };

  // const onFileUpload = () => {
  //   const formData = new FormData();
  //   formData.append("document", imageupload);
  //   mutateAsync(formData).then((response) => {
  //     if (response.success === 1) {
  //       setImageUpload("");
  //     }
  //   });
  // };

  const handleUploadImage = (e) => {
    const files = e.target.files[0];
    setImageUpload(files);
  };
  return (
    <div
      className={`${
        backgroundCol ? backgroundCol : "bg-location-banner"
      } bg-cover bg-no-repeat bg-center flex items-center justify-center py-20`}
    >
      <div className="mainContainer w-full flex flex-wrap lg:flex-nowrap xl:w-9/12 2xl:w-7/12 items-center lg:justify-between justify-center text-white  lg:pl-6">
        {/* ------------Text Content Start------------ */}
        <div className="textContent text-white md:w-11/12 lg:w-[50%] w-full flex flex-col px-4 lg:px-0 ">
          <div className="text ">
            <h1 className="lg:text-40 text-3xl font-secondary font-bold mb-10 leading-8 md:leading-[52px]">
              {ftitle ? ftitle : ""}{" "}
              <span className="text-orange">{midTitle ? midTitle : ""}</span>{" "}
              {secondTitle ? secondTitle : ""}
            </h1>
            <p className="mb-5 text-xl font-opensans tracking-wider ">
              {content}
            </p>
            <p className="mb-5 font-opensans tracking-wider ">{Subcontent}</p>
          </div>

          <div className="grid sm:grid-cols-2 grid-cols-1 mt-12 font-opensans text-md gap-0">
            <div className="flex flex-row">
              <a href="mailto:support@tomedes.com">
                <div className=" lg:w-52 w-44 h-full inline-block mx-auto  lg:my-0">
                  <img src={Email} alt="email" />
                </div>
              </a>
            </div>
            <div className="flex flex-row">
              <a href="tel:+19852390142">
                <div className=" lg:w-52 w-44  h-full inline-block mx-auto  lg:my-0">
                  <img src={CallUs} alt="callus" />
                </div>
              </a>
            </div>
          </div>
        </div>

        <form
          className="form border-white bg-locationFormBorder py-8 lg:justify-between justify-center h-full lg:w-[45%] w-11/12 mt-4 ml-0 lg:ml-4 "
          onSubmit={handleSubmit(onSubmit)}
        >
          <ThankYouPopup open={open} setOpen={setOpen} />

          <div className="inputs flex flex-col items-center justify-center text-black ">
            <div className="w-full lg:ml-[10px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 w-full px-4 md:px6 ">
                {/* <label className="flex flex-col justify-center">
                  <span className="font-opensans text-xs font-semibold">
                    Translate from
                  </span>
                  <input
                    type="text"
                    placeholder="Email Address"
                    className="border-borderGray font-opensans border rounded lg:w-11/12 w-full md:w-[unset] pl-3  h-[34px] text-xs mb-6"
                  />
                </label> */}
                <label htmlFor="" className="flex flex-col">
                  <span className="font-opensans text-xs font-semibold">
                    Translate from
                  </span>
                  <select
                    name=""
                    id=""
                    // className=" bg-white text-[#9e9e9e] py-[10px] px-4 pr-10 mt-4 rounded"
                    className="border-borderGray bg-white font-opensans border rounded lg:w-11/12 w-full md:w-[unset] pl-3  h-[34px] text-xs mb-6"
                    {...register("fromLang", { required: true })}
                    id="fromLang"
                    name="fromLang"
                  >
                    <option disabled selected>
                      Translate from
                    </option>
                    {data
                      ? data?.data?.map(({ source_language }) => (
                          <option className="py-2 px-4 pr-10 mt-4 text-[#9e9e9e] bg-white w-full rounded">
                            {source_language}
                          </option>
                        ))
                      : null}
                  </select>
                </label>
                {/* <label className="flex flex-col">
                  <span className="font-opensans text-xs font-semibold">
                    Translate to
                  </span>
                  <input
                    type="text"
                    placeholder="Email Address"
                    className="border-borderGray font-opensans lg:w-11/12 w-full border rounded  pl-3  h-[34px] text-xs  mb-6"
                  />
                </label> */}
                <label htmlFor="" className="flex flex-col">
                  <span className="font-opensans text-xs font-semibold">
                    Translate to
                  </span>
                  <select
                    name=""
                    id=""
                    // className=" bg-white text-[#9e9e9e] py-[10px] px-4 pr-10 mt-4 rounded"
                    className="border-borderGray bg-white font-opensans border rounded lg:w-11/12 w-full md:w-[unset] pl-3  h-[34px] text-xs mb-6"
                    {...register("toLang", { required: true })}
                    id="toLang"
                    name="toLang"
                  >
                    <option disabled selected>
                      Translate to
                    </option>
                    {data
                      ? data?.data?.map(({ source_language }) => (
                          <option className="py-2 px-4 pr-10 mt-4 text-[#9e9e9e] bg-white w-full rounded">
                            {source_language}
                          </option>
                        ))
                      : null}
                  </select>
                </label>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 w-full px-4 md:px6">
                <label className="flex flex-col">
                  <span className="font-opensans text-xs font-semibold">
                    Name*
                  </span>
                  <input
                    type="text"
                    placeholder="Name"
                    className="border-borderGray font-opensans border rounded  lg:w-11/12 w-full md:w-[unset] pl-3  h-[34px] text-xs  mb-6"
                    {...register("name", { required: true })}
                    id="name"
                    name="name"
                  />
                </label>
                <label className="flex flex-col">
                  <span className="font-opensans text-[12px] font-semibold">
                    Business Email Address*
                  </span>
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="border-borderGray font-opensans border rounded  lg:w-11/12 w-full pl-3  h-[34px] text-xs  mb-6"
                    {...register("email", { required: true })}
                    id="email"
                    name="email"
                  />
                </label>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 w-full px-4 md:px6 ">
                <label className="flex flex-col">
                  <span className="font-opensans text-[12px] font-semibold">
                    Phone Number
                  </span>
                  <input
                    name="phoneNumber"
                    type="tel"
                    placeholder="Enter Your Number Here"
                    className="border-borderGray font-opensans border rounded lg:w-11/12 w-full md:w-[unset] pl-3  h-[34px] text-xs  mb-6"
                    {...register("phoneNumber", { required: true })}
                    id="phoneNumber"
                  />
                </label>
                <label className="flex flex-col">
                  <span className="font-opensans text-[12px] font-semibold">
                    Upload file / link
                  </span>
                  <input
                    name="document"
                    type="file"
                    placeholder="Share a link to"
                    className="border-borderGray font-opensans border rounded lg:w-11/12 w-full pl-3  h-[34px] text-xs mb-6"
                    // {...register("document", { required: true })}
                    id="document"
                    onChange={handleUploadImage}
                    required
                    value={imageupload}
                  />
                </label>
              </div>
            </div>

            <textarea
              className="border-borderGray font-opensans border rounded  pl-3 w-[90%] text-xs"
              name="message"
              id=""
              cols="30"
              rows="4"
              placeholder="Tell us more about your needs"
              {...register("message", { required: true })}
              id="message"
              name="message"
            ></textarea>
            <button
              href="/"
              className="bg-orange py-2 text-center font-secondary font-extrabold mt-6 text-white block w-11/12"
              // onClick={onFileUpload}
            >
              {status === "loading" ? <Loader /> : "SUBMIT"}{" "}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewBanner;
